<script setup lang="ts">
import IconHeartPlusOutline from '@icons/ph_heart-plus-outline.svg';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import { trans } from '@elements/translation';
</script>

<template>
  <div class="selection-item-empty-state">
    <div
      class="selection-item-empty-state__icon-wrapper"
    >
      <Icon
        :svg="IconHeartPlusOutline"
        fill="blue"
        width="40"
        height="40"
      />
    </div>

    <Typography
      variant="content-heading-1"
      class="selection-item-empty-state__title"
    >
      {{ trans('selection_item.state.title') }}
    </Typography>

    <div>
      <slot name="description" />
    </div>

    <div class="selection-item-empty-state__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-empty-state {
  border: 1px solid $colorGray;
  border-radius: rem(8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: rem(8);
  text-align: center;
  height: 100%;
  padding: rem(32) rem(24);

  &__actions {
    margin-top: rem(24);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: rem(8);
    width: auto;
  }

  &__icon-wrapper {
    height: rem(72);
    width: rem(72);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $colorBlueLighter;
  }
}
</style>
